<template>
  <div class="payPage">
    <div class="paybox">
      <div class="topbg"></div>
      <div class="contant">
        <div class="logo"><img src="/assets/web/img/logo.png" alt=""></div>
        <div class="itemname">{{ $order['pay_body'] }}</div>
        <div class="price">￥{{ $order['pre_pay_money'] }}</div>
        <div class="itemid">订单号：{{ $order['order_no'] }}</div>
        <div class="btnbox">
          <button type="button" id="payStatus" class="paybtn" onclick="{{ $redirect_uri?'toBack()':'toClose()'}}">{{
            $order['status_str'] }}</button>
        </div>
      </div>
    </div>
    <div id='msg'></div>
    <div id='myForm'></div>
  </div>
</template>

<script setup>
/*
let error_msg = "{{ $error_msg??'' }}";
if (error_msg) {
  errMsg(error_msg);
} else {
  if (typeof WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
    }
  } else {
    onBridgeReady();
  }
}
function onBridgeReady() {
  try {
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest',
      {
        appId: "{{ $jsApiParameters['appId']??'' }}",
        timeStamp: "{{ $jsApiParameters['timeStamp']??'' }}",
        nonceStr: "{{ $jsApiParameters['nonceStr']??'' }}",
        package: "{{ $jsApiParameters['package']??'' }}",
        signType: "{{ $jsApiParameters['signType']??'' }}",
        paySign: "{{ $jsApiParameters['paySign']??'' }}"
      },
      function (res) {
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          if ({{ strpos($redirect_uri ?? '', 'toAuth') !== false ? 1 : 0 }
        }){
      document.getElementById('payStatus').innerHTML = '跳转登录';
      setTimeout(function () { toBack() }, 100);
    }else {
      document.getElementById('payStatus').innerHTML = '支付成功';
    }
  } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
    document.getElementById('payStatus').innerHTML = '取消支付';
    document.getElementById('paybtn').innerHTML = '取消支付';
  } else if (res.err_msg == 'get_brand_wcpay_request:fail') {
    document.getElementById('payStatus').innerHTML = '支付失败';
    document.getElementById('paybtn').innerHTML = '支付失败';
  }
}
                    );
                } catch (e) {
  alert(JSON.stringify({ e: e }));
}
            }
function callpay() {
  try {
    if (typeof WeixinJSBridge == "undefined") {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', jsApiCall);
        document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
      }
    } else {
      jsApiCall();
    }
  } catch (e) {
    alert(JSON.stringify({ e: e }));
  }
}
function toBack() {
  window.location.href = "{{ $redirect_uri??'' }}";
}
// 错误提示弹窗
function errMsg(erromsg) {
  $("#msg").text(erromsg);
}
function toClose() {
  let ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger\/[0-9]/i)) {
    WeixinJSBridge.call('closeWindow');
  }
  if (window.AlipayJSBridge) {
    window.AlipayJSBridge.call('closeWebview');
  }
  window.close();
}*/
</script>

<style lang="less" scoped>
@import url("/wap/css/css.css");
.payPage {
  height: 100vh;
  width: 100vw;
  background: #f5f5f5;
  font-size: 20px;
  overflow-y: auto;
}

.paybox {
  width: 100vw;
  height: 100vh;
  position: relative;
}

.topbg {
  width: 100%;
  height: 25vh;
  background-image: linear-gradient(to bottom right, #018fef, #1075d4);
  border-radius: 0 0 50% 50%;
}

.contant {
  width: 90vw;
  height: 85vh;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate3d(-50%, -50%, 0);
  transform: translate3d(-50%, -50%, 0);
  background-color: #fff;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: column;
}

.contant .logo {
  width: 60%;
  margin-bottom: 3rem;
}

.contant .logo img {
  width: 100%;
  display: block;
}

.contant .itemname {
  font-size: 1.8rem;
  line-height: 1.8rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.contant .price {
  font-size: 2.6rem;
  line-height: 2.6rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.contant .itemid {
  font-size: 1rem;
  line-height: 1rem;
  color: #9c9c9c;
  margin-bottom: 3rem;
}

.contant .btnbox {
  width: 50%;
}

.contant .btnbox button {
  width: 100%;
  display: block;
  font-size: 1.2rem;
  color: #fff;
  margin-bottom: 1rem;
  height: 3rem;
}

.contant .paybtn {
  background: #1a88ef;
}

.contant .cancer {
  background: #9c9c9c;
}

#msg {
  color: red;
}

/*错误弹窗*/
.erro_msg {
  padding: 1rem 1rem;
  box-sizing: border-box;
  border-radius: 0.3rem;
  overflow: hidden;
  background-color: #3e4047;
  position: fixed;
  left: 10%;
  top: 40%;
  width: 80%;
  margin-top: -5rem;
  height: 6rem;
  z-index: 13;
  font-size: 0.65rem;
}

.erro_msg .box_mes {
  color: #fff;
  font-size: 0.75rem;
  margin: 0.5rem 0.3rem 1rem 0.3rem;
  text-align: center;
}

.erro_msg .box_btn {
  display: block;
  text-align: center;
}

.erro_msg .box_btn button {
  border-radius: 0.3rem;
  padding: 0.3rem 0.8rem;
  font-size: 0.75rem;
}

.erro_msg .box_btn .ok_btn {
  background-color: #0076f5;
  color: #fff;
}
</style>